import React, { useState, useEffect, useRef, useCallback } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
import Moment from "moment";
import * as Yup from "yup";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
// import Loader from "../../biztran_controls/Loader";


Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

const CreateDeliveryChallan = (props) => {
    //10-feb- change
    const classes = useStyles();
    const [DeliveryChallanNo, setDeliveryChallanNo] = useState(props.DCMainData === undefined || props.DCMainData[0].DeliveryChallanNo === null ? '' : props.DCMainData[0].DeliveryChallanNo);
    // const [DeliveryChallanDate, setDeliveryChallanDate] = useState(Moment(new Date()).format("YYYY-MMM-DD"));
    const [DeliveryChallanDate, setDeliveryChallanDate] = useState(props.DCMainData === undefined || props.DCMainData[0].DeliveryChallanDate === null ? Moment(new Date()).format("DD-MMM-YYYY") : Moment(props.DCMainData[0].DeliveryChallanDate).format("YYYY-MM-DD"));
    const [AccountID, setAccountID] = useState(props.DCMainData === undefined || props.DCMainData[0].AccountID === null ? '' : props.DCMainData[0].AccountID);
    const [AccountName, setAccountName] = useState(props.DCMainData === undefined || props.DCMainData[0].AccountName === null ? { id: props.AccountID, AccountName: props.AccountName } : { id: props.DCMainData[0].AccountID, List: props.DCMainData[0].AccountName });
    const [ACAccount, setACAccount] = useState([]);
    const [responseCust, fetchCustData] = UseFetchData();
    const [Mode, setMode] = useState("");
    const [LeadSourceID, setLeadSourceID] = useState(props.DCMainData === undefined || props.DCMainData[0].LeadSourceID === null ? '' : props.DCMainData[0].LeadSourceID);
    // const [ContactID, setContactID] = useState("");
    const [DeliveryChallanType, setDeliveryChallanType] = useState('');
    const [CompanyID, setCompanyID] = useState(props.DCMainData === undefined || props.DCMainData[0].CompanyID === null ? '' : props.DCMainData[0].CompanyID);
    const [Description, setDescription] = useState(props.DCMainData === undefined || props.DCMainData[0].Description === null ? '' : props.DCMainData[0].Description);
    const [BillAddress1, setBillAddress1] = useState(props.DCMainData === undefined || props.DCMainData[0].BillAddress1 === null ? '' : props.DCMainData[0].BillAddress1);
    const [BillAddress2, setBillAddress2] = useState(props.DCMainData === undefined || props.DCMainData[0].BillAddress2 === null ? '' : props.DCMainData[0].BillAddress2);
    const [BillCity, setBillCity] = useState(props.DCMainData === undefined || props.DCMainData[0].BillCity === null ? '' : props.DCMainData[0].BillCity);
    const [BillCountryID, setBillCountryID] = useState(props.DCMainData === undefined || props.DCMainData[0].BillCountryID === null ? '' : props.DCMainData[0].BillCountryID);
    const [BillStateID, setBillStateID] = useState(props.DCMainData === undefined || props.DCMainData[0].BillStateID === null ? '' : props.DCMainData[0].BillStateID);
    const [BillPINCode, setBillPINCode] = useState(props.DCMainData === undefined || props.DCMainData[0].BillPINCode === null ? '' : props.DCMainData[0].BillPINCode);
    const [ShipAddress1, setShipAddress1] = useState(props.DCMainData === undefined || props.DCMainData[0].ShipAddress1 === null ? '' : props.DCMainData[0].ShipAddress1);
    const [ShipAddress2, setShipAddress2] = useState(props.DCMainData === undefined || props.DCMainData[0].ShipAddress2 === null ? '' : props.DCMainData[0].ShipAddress2);
    const [ShipCity, setShipCity] = useState(props.DCMainData === undefined || props.DCMainData[0].ShipCity === null ? '' : props.DCMainData[0].ShipCity);
    const [ShipCountryID, setShipCountryID] = useState(props.DCMainData === undefined || props.DCMainData[0].ShipCountryID === null ? '' : props.DCMainData[0].ShipCountryID);
    const [ShipStateID, setShipStateID] = useState(props.DCMainData === undefined || props.DCMainData[0].ShipStateID === null ? '' : props.DCMainData[0].ShipStateID);
    const [ShipPINCode, setShipPINCode] = useState(props.DCMainData === undefined || props.DCMainData[0].ShipPINCode === null ? '' : props.DCMainData[0].ShipPINCode);
    const [Accountcmb, setAccountcmb] = useState([]);
    const [Companycmb, setCompanycmb] = useState([]);
    const [Contactcmb, setContactcmb] = useState([]);
    const [LeadSourcecmb, setLeadSourcecmb] = useState([]);
    const [BillCountrycmb, setBillCountrycmb] = useState([]);
    const [BillStatecmb, setBillStatecmb] = useState([]);
    const [ShipCountrycmb, setShipCountrycmb] = useState([]);
    const [ShipStatecmb, setShipStatecmb] = useState([]);
    const [IncoTerms, setIncoTerms] = useState(props.DCMainData === undefined || props.DCMainData[0].IncoTerms === null ? '' : props.DCMainData[0].IncoTerms);
    const [Delivery, setDelivery] = useState(props.DCMainData === undefined || props.DCMainData[0].Delivery === null ? '' : props.DCMainData[0].Delivery);
    const [isChecked, setIsChecked] = useState(false);
    const [Origin, setOrigin] = useState(props.DCMainData === undefined || props.DCMainData[0].Origin === null ? 'INDIA' : props.DCMainData[0].Origin);
    const [Warranty, setWarranty] = useState(props.DCMainData === undefined || props.DCMainData[0].Warranty === null ? '' : props.DCMainData[0].Warranty);
    const [Weight, setWeight] = useState(props.DCMainData === undefined || props.DCMainData[0].Weight === null ? '' : props.DCMainData[0].Weight);
    const [BoxSize, setBoxSize] = useState(props.DCMainData === undefined || props.DCMainData[0].BoxSize === null ? '' : props.DCMainData[0].BoxSize);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [response, fetchData] = UseFetchData();
    const [responseAccDtls, fetchAccDtlsData] = UseFetchData();
    const [responsContactDtls, fetchContactDtlsData] = UseFetchData();
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const ref = useRef(null);
    const [loading, setLoading] = useState(true);
    const [DisableSaveBtn, setDisableSaveBtn] = useState(false);


    const GetAccountData = (AccountID) => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("AccountID", AccountID);
        setLoading(true);
        fetchAccDtlsData("Account/GetByID", bodyFormData);
    };

    const validationSchema = Yup.object({
        DeliveryChallanDate: Yup.string().required("Required!"),
    });


    useEffect(() => {
        //10- feb change
        GetComboData();
        // CustData();
    }, []);

    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        // setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };

    const onSubmit = (values) => {
        setMode("Insert");
        var UpdatedByID = sessionStorage.UID;
        var GeneratedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        var DeliveryChallanID = "";
        // debugger
        if (props.Mode === "Insert") {
            DeliveryChallanID = '';
        }
        else {
            DeliveryChallanID = props.DeliveryChallanID;
        }
        bodyFormData.append("DeliveryChallanID", DeliveryChallanID);
        bodyFormData.append("DeliveryChallanNo", values.DeliveryChallanNo);
        bodyFormData.append("DeliveryChallanDate", values.DeliveryChallanDate);
        bodyFormData.append("AccountID", values.AccountID);
        bodyFormData.append("LeadSourceID", values.LeadSourceID);
        bodyFormData.append("CompanyID", values.CompanyID);
        // bodyFormData.append("ContactID", values.ContactID);
        bodyFormData.append("Description", values.Description);
        bodyFormData.append("DeliveryChallanType", values.DeliveryChallanType);
        bodyFormData.append("BillAddress1", values.BillAddress1);
        bodyFormData.append("BillAddress2", values.BillAddress2);
        bodyFormData.append("BillCity", values.BillCity);
        bodyFormData.append("BillStateID", values.BillStateID);
        bodyFormData.append("BillCountryID", values.BillCountryID);
        bodyFormData.append("BillPINCode", values.BillPINCode);
        bodyFormData.append("ShipAddress1", values.ShipAddress1);
        bodyFormData.append("ShipAddress1", values.ShipAddress1);
        bodyFormData.append("ShipAddress2", values.ShipAddress2);
        bodyFormData.append("ShipCity", values.ShipCity);
        bodyFormData.append("ShipStateID", values.ShipStateID);
        bodyFormData.append("ShipCountryID", values.ShipCountryID);
        bodyFormData.append("ShipPINCode", values.ShipPINCode);
        bodyFormData.append("ShipAddress1", values.ShipAddress1);
        bodyFormData.append("GeneratedByID", GeneratedByID);
        bodyFormData.append("HandledByID", GeneratedByID);
        bodyFormData.append("UpdatedByID", UpdatedByID);
        bodyFormData.append("IncoTerms", values.IncoTerms);
        bodyFormData.append("Origin", values.Origin);
        bodyFormData.append("Warranty", values.Warranty);
        bodyFormData.append("Weight", values.Weight);
        bodyFormData.append("BoxSize", values.BoxSize);
        bodyFormData.append("Delivery", values.Delivery);
        setDisableSaveBtn(true);
        fetchData("DeliveryChallan/Save", bodyFormData);
    }

    useEffect(() => {
        //// debugger;
        if (isChecked) {
            setShipAddress1(BillAddress1);
            setShipAddress2(BillAddress2);
            setShipCountryID(BillCountryID);
            setShipStateID(BillStateID);
            setShipCity(BillCity);
            setShipPINCode(BillPINCode);
        }
        else if (props.DeliveryChallanID !== undefined && ShipAddress1 !== "") {
            setShipAddress1(BillAddress1);
            setShipAddress2(BillAddress2);
            setShipCountryID(BillCountryID);
            setShipStateID(BillStateID);
            setShipCity(BillCity);
            setShipPINCode(BillPINCode);
        }
        else {
            setShipAddress1("");
            setShipAddress2("");
            setShipCountryID("");
            setShipStateID("");
            setShipCity("");
            setShipPINCode("");
        }
    }, [isChecked]);

    const LeadSourceData = useCallback((options) => {
        if (options !== undefined) {
            let LeadSource = options.map((data) => (
                <option key={data.LeadSource} value={data.LeadSourceID}>
                    {data.LeadSource}
                </option>
            ));
            setLeadSourcecmb(LeadSource);
        }
    }, []);


    const CompanyData = React.useCallback((options) => {
        if (options !== undefined) {
            let Company = options.map((data) => (
                <option key={data.CompanyName} value={data.CompanyID}>
                    {data.CompanyName}
                </option>
            ));
            setCompanycmb(Company);
        }
    }, []);

    const CountryData = React.useCallback((options) => {
        if (options !== undefined) {
            let Country = options.map((data) => (
                <option key={data.Country} value={data.CountryID}>
                    {data.Country}
                </option>
            ));
            setBillCountrycmb(Country);
            setShipCountrycmb(Country);
        }
    }, []);

    const BillStatecmbData = (CID) => {
        //// debugger;
        var id = "";
        if (CID !== "") {
            id = CID;
        } else if (BillCountryID !== "") {
            id = BillCountryID;
        } else {
            id = "";
        }
        let options = ComboDataResponse["State"];
        if (options !== undefined) {
            if (id !== "") {
                let State = options
                    .filter((option) => option.CountryID === id)
                    .map((data) => (
                        <option key={data.StateName} value={data.StateID}>
                            {data.StateName}
                        </option>
                    ));
                setBillStatecmb(State);
            }

            else {
                let State = options.map((data) => (
                    <option key={data.StateName} value={data.StateID}>
                        {data.StateName}
                    </option>
                ));
                setBillStatecmb(State);
            }
        }
    };


    const ShipStatecmbData = (CID) => {
        var id = "";
        if (CID !== "") {
            id = CID;
        } else if (BillCountryID !== "") {
            id = BillCountryID;
        } else {
            id = "";
        }
        let options = ComboDataResponse["State"];
        if (options !== undefined) {
            if (id !== "") {
                let State = options
                    .filter((option) => option.CountryID === id)
                    .map((data) => (
                        <option key={data.StateName} value={data.StateID}>
                            {data.StateName}
                        </option>
                    ));
                setShipStatecmb(State);
            }
            else {
                let State = options.map((data) => (
                    <option key={data.StateName} value={data.StateID}>
                        {data.StateName}
                    </option>
                ));
                setShipStatecmb(State);
            }
        }
    };

    const GetComboData = async () => {
        //10-feb change
        await fetchComboData("DeliveryChallan/ComboData");
    };

    const onAccountSelectChange = React.useCallback((e, ACData) => {
        setAccountID(ACData.id);
        setAccountName(ACData);
        GetAccountData(ACData.id);
        // GetContactData(ACData.id);
    }, []);

    const onCheckChange = (e) => {
        //// debugger;
        setIsChecked(e.target.checked);
        console.log(isChecked);
    };

    const onSelectChange = (e) => {
        //// debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "AccountID") {
                setAccountID(targetvalue);
                GetAccountData(targetvalue);
                // GetContactData(targetvalue);
            } else if (targetname === "LeadSourceID") {
                setLeadSourceID(targetvalue);
            } else if (targetname === "CompanyID") {
                setCompanyID(targetvalue);
                // } else if (targetname === "ContactID") {
                // setContactID(targetvalue);
            } else if (targetname === "BillCountryID") {
                setBillCountryID(targetvalue);
                BillStatecmbData(targetvalue);
            } else if (targetname === "BillStateID") {
                // BillStatecmbData(targetvalue);
                setBillStateID(targetvalue);
            } else if (targetname === "ShipCountryID") {
                setShipCountryID(targetvalue);
                ShipStatecmbData(targetvalue);
            } else if (targetname === "ShipStateID") {
                // ShipStatecmbData(targetvalue);
                setShipStateID(targetvalue);
            }
        } else {
            if (targetname === "AccountID") {
                setAccountID("");
                GetAccountData("");
                setBillAddress1('');
                setBillAddress2('');
                setBillCity('');
                setBillCountryID('');
                setBillStateID('');
                setBillPINCode('');
            } else if (targetname === "LeadSourceID") {
                setLeadSourceID("");
            } else if (targetname === "CompanyID") {
                setCompanyID("");
            } else if (targetname === "BillCountryID") {
                setBillCountryID("");
                setBillStatecmb([]);
            } else if (targetname === "BillStateID") {
                setBillStateID("");
            } else if (targetname === "ShipCountryID") {
                setShipStateID("");
                setShipStatecmb([]);
            } else if (targetname === "ShipStateID") {
                setShipStateID("");
            }
        }
    };

    useEffect(() => {
        //10-feb change
        //// debugger;
        // LeadSourceData(props.cmbLeadSourceData.length > 0 ? props.cmbLeadSourceData : []);
        // CountryData(props.cmbCountryData.length > 0 ? props.cmbCountryData : []);
        // CompanyData(props.cmbCompanyData.length > 0 ? props.cmbCompanyData : []);
        if (ComboDataResponse['LeadSource'] !== undefined && ComboDataResponse['LeadSource'].length > 0) {
            // setLoading(true);
            LeadSourceData(ComboDataResponse["LeadSource"]);
        }
        if (ComboDataResponse['Country'] !== undefined && ComboDataResponse['LeadSource'].length > 0) {
            // setLoading(true);
            CountryData(ComboDataResponse["Country"]);
        }
        if (ComboDataResponse['Company'] !== undefined && ComboDataResponse['LeadSource'].length > 0) {
            // setLoading(true);
            CompanyData(ComboDataResponse["Company"]);
        }
        if (ComboDataResponse['cmbAccount'] !== undefined && ComboDataResponse['cmbAccount'].length > 0) {
            setACAccount(ComboDataResponse['cmbAccount']);
        }
        if (props.DeliveryChallanID !== "") {
            BillStatecmbData("");
            ShipStatecmbData("");
            setMode("Update");
        } else {
            setMode("Insert");
        }

    }, [ComboDataResponse])



    useEffect(() => {
        //// debugger;
        if ((response.Response === true) && (Mode === 'Insert')) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
            setDisableSaveBtn(true);
        }
        else if (response.Response === false) {
            alert('Failed.');
            setDisableSaveBtn(false);
        }
    }, [response])


    useEffect(() => {
        if (responseAccDtls !== undefined && responseAccDtls.length > 0) {
            setLoading(false);
            setBillAddress1(responseAccDtls[0].BillAddress1 === null ? "" : responseAccDtls[0].BillAddress1);
            setBillAddress2(responseAccDtls[0].BillAddress2 === null ? "" : responseAccDtls[0].BillAddress2);
            setBillCity(responseAccDtls[0].BillCity === null ? "" : responseAccDtls[0].BillCity);
            setBillCountryID(responseAccDtls[0].BillCountryID === null ? "" : responseAccDtls[0].BillCountryID);
            setBillStateID(responseAccDtls[0].BillStateID === null ? "" : responseAccDtls[0].BillStateID);
            setBillPINCode(responseAccDtls[0].BillPINCode === null ? "" : responseAccDtls[0].BillPINCode);
            setShipAddress1(responseAccDtls[0].ShipAddress1 === null ? "" : responseAccDtls[0].ShipAddress1);
            setShipAddress2(responseAccDtls[0].ShipAddress2 === null ? "" : responseAccDtls[0].ShipAddress2);
            setShipCity(responseAccDtls[0].ShipCity === null ? "" : responseAccDtls[0].ShipCity);
            setShipCountryID(responseAccDtls[0].ShipCountryID === null ? "" : responseAccDtls[0].ShipCountryID);
            setShipStateID(responseAccDtls[0].ShipStateID === null ? "" : responseAccDtls[0].ShipStateID);
            setShipPINCode(responseAccDtls[0].ShipPINCode === null ? "" : responseAccDtls[0].ShipPINCode);
        }
    }, [responseAccDtls])


    return <div>
        {/* {
            loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 10,
                }}>
                    <Loader />
                </div>
            )
        } */}
        <Formik initialValues={{
            DeliveryChallanNo: DeliveryChallanNo, DeliveryChallanDate: DeliveryChallanDate, AccountID: AccountID, LeadSourceID: LeadSourceID, DeliveryChallanType: DeliveryChallanType, CompanyID: CompanyID,
            Description: Description, BillAddress1: BillAddress1, BillAddress2: BillAddress2, BillCity: BillCity, BillCountryID: BillCountryID, BillStateID: BillStateID,
            BillPINCode: BillPINCode, ShipAddress1: ShipAddress1, ShipAddress2: ShipAddress2, ShipCity: ShipCity, ShipCountryID: ShipCountryID, ShipStateID: ShipStateID, ShipPINCode: ShipPINCode,
            Delivery: Delivery, IncoTerms: IncoTerms, Origin: Origin, Warranty: Warranty, Weight: Weight, BoxSize: BoxSize
        }}
            validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize
        >
            {(formik) => {
                return (
                    <Form>
                        <Typography style={{ margingTop: "-16px", marginBottom: "10px" }} className={classes.headertext} noWrap>
                            Delivery Challan Information
                        </Typography>
                        <Grid spacing={1} container direction="row">
                            <Grid xs={2}>
                                <label
                                    htmlFor={"DeliveryChallanNo"}
                                    style={{ display: "block", width: "100%" }}
                                >
                                    {"DeliveryChallanNo"}
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="DeliveryChallanNo"
                                    disabled={true}
                                    onChange={(e) => setDeliveryChallanNo(e.target.value)}
                                />
                            </Grid>
                            <Grid xs={2}>
                                <label
                                    htmlFor={"DeliveryChallanDate"}
                                    style={{ display: "block", width: "100%" }}
                                >
                                    {"DeliveryChallanDate"}
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="DeliveryChallanDate"
                                    disabled={true}
                                    onChange={(e) => setDeliveryChallanDate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label htmlFor={"AccountID"}
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                    }}>
                                    {"Account"}
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <BiztranControls.Autocomplete
                                    options={ACAccount}
                                    onChange={onAccountSelectChange}
                                    value={AccountName}
                                    name="AccountID"
                                />
                            </Grid>
                            {/* <Grid item xs={2}>
                                <label
                                    htmlFor={"AccountID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Account"}
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <BiztranControlsFormik
                                    control="select"
                                    name="AccountID"
                                    options={Accountcmb}
                                    onChange={onSelectChange}
                                />
                            </Grid> */}

                            {/* <Grid item xs={2}>
                                <label
                                    htmlFor={"ContactID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Contact"}
                                </label>
                            </Grid> */}
                            {/* <Grid item xs={4}>
                                <BiztranControlsFormik
                                    control="select"
                                    name="ContactID"
                                    options={Contactcmb}
                                    onChange={onSelectChange}
                                />
                            </Grid> */}
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"CompanyID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Company"}
                                </label>
                            </Grid>
                            <Grid item xs={4}>
                                <BiztranControlsFormik
                                    control="select"
                                    name="CompanyID"
                                    options={Companycmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={2}>
                                    <label
                                        htmlFor={"Description"}
                                        style={{ display: "block", width: "100%" }}
                                    >
                                        {"Description"}
                                    </label>
                                </Grid>
                                <Grid item xs={10}>
                                    <BiztranControlsFormik
                                        control="textarea"
                                        type="text"
                                        name="Description"
                                        ref={ref}
                                        value={Description}
                                        onChange={(e) => {
                                            setDescription(e.target.value)
                                            handleChange()
                                        }
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} style={{ margingTop: 3 }}>
                                <Typography className={classes.headertext} noWrap>
                                    Address Information
                                </Typography>
                            </Grid>
                            <Grid item xs={8} style={{ display: "flex", marginLeft: "50%" }}>
                                <label>Shipping Address Same as Billing Address ?</label>
                                <div style={{ paddingLeft: 10 }}>
                                    <input
                                        type="checkbox"
                                        name="chkbox"
                                        checked={isChecked}
                                        onChange={onCheckChange}
                                    ></input>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="textarea"
                                    type="text"
                                    label="BillAddress 1"
                                    name="BillAddress1"
                                    ref={ref}
                                    value={BillAddress1}
                                    onChange={(e) => {
                                        setBillAddress1(e.target.value)
                                        handleChange()
                                    }
                                    }
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="textarea"
                                    type="text"
                                    label="ShipAddress 1"
                                    name="ShipAddress1"
                                    ref={ref}
                                    value={ShipAddress1}
                                    onChange={(e) => {
                                        setShipAddress1(e.target.value)
                                        handleChange()
                                    }
                                    }
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="textarea"
                                    type="text"
                                    label="BillAddress 2"
                                    name="BillAddress2"
                                    ref={ref}
                                    value={BillAddress2}
                                    onChange={(e) => {
                                        setBillAddress2(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="textarea"
                                    type="text"
                                    label="ShipAddress 2"
                                    name="ShipAddress2"
                                    ref={ref}
                                    value={ShipAddress2}
                                    onChange={(e) => {
                                        setShipAddress2(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="select"
                                    label="Bill Country"
                                    name="BillCountryID"
                                    options={BillCountrycmb}
                                    onChange={onSelectChange}

                                />
                            </Grid>
                            {/* {BillCountryID === "FA4EFB9C-68D1-419D-899E-7635E19A5758" ? */}

                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="select"
                                    label="Bill State"
                                    name="BillStateID"
                                    options={BillStatecmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            {/* :null} */}
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="select"
                                    label="Ship Country"
                                    name="ShipCountryID"
                                    options={BillCountrycmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="select"
                                    label="Ship State"
                                    name="ShipStateID"
                                    options={ShipStatecmb}
                                    onChange={onSelectChange}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="Bill City"
                                    name="BillCity"
                                    ref={ref}
                                    value={BillCity}
                                    onChange={(e) => {
                                        setBillCity(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    label="Bill PINCODE"
                                    type="text"
                                    name="BillPINCODE"
                                    ref={ref}
                                    value={BillPINCode}
                                    onChange={(e) => {
                                        setBillPINCode(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="Ship City"
                                    name="ShipCity"
                                    ref={ref}
                                    value={ShipCity}
                                    onChange={(e) => {
                                        setShipCity(e.target.value)
                                        handleChange()
                                    }
                                    }
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="Ship PINCODE"
                                    name="ShipPINCODE"
                                    ref={ref}
                                    value={ShipPINCode}
                                    onChange={(e) => {
                                        setShipPINCode(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography className={classes.headertext} noWrap>
                                    Terms & Conditions
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="Delivery"
                                    name="Delivery"
                                    ref={ref}
                                    value={Delivery}
                                    onChange={(e) => {
                                        setDelivery(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="IncoTerms"
                                    name="IncoTerms"
                                    ref={ref}
                                    value={IncoTerms}
                                    onChange={(e) => {
                                        setIncoTerms(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="Origin"
                                    name="Origin"
                                    ref={ref}
                                    value={Origin}
                                    onChange={(e) => {
                                        setOrigin(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="Warranty"
                                    name="Warranty"
                                    ref={ref}
                                    value={Warranty}
                                    onChange={(e) => {
                                        setWarranty(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="Weight"
                                    name="Weight"
                                    onChange={(e) => setWeight(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    label="BoxSize"
                                    name="BoxSize"
                                    ref={ref}
                                    value={BoxSize}
                                    onChange={(e) => {
                                        setBoxSize(e.target.value)
                                        handleChange()
                                    }
                                    } />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignContent: "center"
                                        }}
                                    >
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            disabled={DisableSaveBtn}
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => {
                                                props.setOpen(false);
                                            }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                )
            }}
        </Formik>

    </div>
};
const useStyles = makeStyles((thems) => ({
    headertext: {
        background: "#e6d8d8",
        color: "#3d3d3d",
        height: "2rem",
        paddingLeft: "30px",
        fontSize: "1.5rem",
        marginLeft: "-24px",
        marginRight: "-24px",
    },
}
));

export default CreateDeliveryChallan;